// Brand settings > White Label (brand admins): the same editor internal staff
// use on brand detail > Network, minus the PDP-audit guidance. The allowed
// domains gate the brand's category / brand imports; the API rejects
// retailers, marketplaces, shared hosts and other networks' domains.
import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import axiosInstant from '../../../api';
import { getBrand } from '../../../api/endpoints';
import { useUser } from '../../../hooks/useUser';
import { useWorkspaceBrandId } from '../../../hooks/useWorkspaceBrandId';
import { WhiteLabelSettingsForm } from '../rmn/WhiteLabelSettingsPanel';

export default function BrandWhiteLabelSettings() {
  const { brand: userBrands } = useUser();
  const workspaceBrandId = useWorkspaceBrandId();
  const brandId = workspaceBrandId || (userBrands ? userBrands[0].id : 0);
  const [brand, setBrand] = useState<any>(null);

  useEffect(() => {
    let cancelled = false;
    if (brandId) {
      axiosInstant
        .get(getBrand(brandId))
        .then((response) => {
          if (!cancelled) setBrand(response.data);
        })
        .catch(() => undefined);
    }
    return () => {
      cancelled = true;
    };
  }, [brandId]);

  if (!brand) {
    return (
      <Typography variant="body1" sx={{ opacity: 0.7 }}>
        Loading…
      </Typography>
    );
  }

  // The form seeds its fields from the brand once; remount on each saved
  // brand so the fields show what the API stored (sanitized domains).
  return (
    <WhiteLabelSettingsForm
      key={JSON.stringify(brand.allowed_domains || [])}
      brand={brand}
      setBrand={setBrand}
    />
  );
}
